// extracted by mini-css-extract-plugin
export var hideEditor = "_lm-2";
export var infoIcon = "_lm-3";
export var label = "_lm-1";
export var labelContainer = "_lm-0";
export var readonlyText = "_lm-4";